import styled from "styled-components";
import {flexCenterAlignItemsMixin, flexColumnContainerMixin, flexRowContainerMixin} from "../../../../../themes/architecture/css-helpers/flex";

export const GameNavBarWrapperDefaultBox = styled.div`
    @media ${({theme}) => theme.mediaQuery.landscape} {
        width: 48px;
        height: 100%;
        ${flexColumnContainerMixin}
    }
    @media ${({theme}) => theme.mediaQuery.portrait} {
        width: 100%;
        height: 48px;
        ${flexRowContainerMixin}
    }
    ${flexCenterAlignItemsMixin}
    background-color: ${({theme}) => theme.colors.backgroundDark};
    color: ${({theme}) => theme.colors.text};
`;